import { NotificationService, useIntl, useSettings } from '@capsicum/common';
import { Notification } from '@capsicum/common-web';
import { type GeetestChallengeMetadata, type GenerateCodeParams } from '@capsicum/socios-core';
import { useCallback } from 'react';

import { type GeeTestRef } from '../login/user-details/GeeTestContainer/GeeTestContainer';

type UseTriggerCaptcha = {
	captcha: GeeTestRef | null;
};

export const useTriggerCaptcha = ({ captcha }: UseTriggerCaptcha) => {
	const { $t } = useIntl();
	const {
		settings: { isGeetestDisabledCapsicum }
	} = useSettings();

	return useCallback(
		({ metadata }: { metadata?: GeetestChallengeMetadata } = {}) => {
			return new Promise<GenerateCodeParams['captchaInformation']>((resolve, reject) => {
				if (!captcha) return reject(new Error('captchaRef is null'));

				if (isGeetestDisabledCapsicum === true) {
					return resolve({
						captchaId: '123',
						captchaOutput: '123',
						genTime: '123',
						lotNumber: '123',
						passToken: 'temp'
					});
				}

				captcha.runCaptcha(
					response => {
						resolve({
							captchaId: response.captcha_id,
							captchaOutput: response.captcha_output,
							genTime: response.gen_time,
							lotNumber: response.lot_number,
							passToken: response.pass_token
						});
					},
					() => {
						NotificationService.addNotification({
							component: (
								<Notification
									message={$t('auth.geetestError')}
									title={$t('global.tryAgainLater')}
									variant="error"
								/>
							)
						});

						reject(new Error('Geetest challenge failed'));
					},
					metadata
				);
			});
		},
		[$t, captcha, isGeetestDisabledCapsicum]
	);
};
